import { UPLOAD_ZONE_RATE_FAILURE, UPLOAD_ZONE_RATE_REQUEST, UPLOAD_ZONE_RATE_REST, UPLOAD_ZONE_RATE_SUCCESS } from "@/redux/actions";
const initialState = {
    data: null,
    loading: false,
    error: null,
};
const uploadZoneRateReducer = (state = initialState, action) => {
    switch (action.type) {
        case UPLOAD_ZONE_RATE_SUCCESS:
            return Object.assign(Object.assign({}, state), { loading: false, error: null, data: action.payload });
        case UPLOAD_ZONE_RATE_REQUEST:
            return Object.assign(Object.assign({}, state), { loading: true, data: null, error: null });
        case UPLOAD_ZONE_RATE_FAILURE:
            return Object.assign(Object.assign({}, state), { loading: false, error: action.payload });
        case UPLOAD_ZONE_RATE_REST:
            return Object.assign(Object.assign({}, state), { loading: true, data: null, error: null });
        default:
            return state;
    }
};
export default uploadZoneRateReducer;
